'use client'

import { useHydration } from '@/hooks/use-hydration'
import { documentToReactComponents, Options } from '@contentful/rich-text-react-renderer'
import { MARKS } from '@contentful/rich-text-types'
import ExportedImage from 'next-image-export-optimizer'
import { Fragment } from 'react'

import { Buble } from '@/components/atoms/buble'
import { Loading } from '@/components/atoms/icons'
import { Button } from '@/components/atoms/ui/button'
import Container from '@/components/templates/container/container'

interface Props {
  data: PMA
}

export const PMAHero = ({ data }: Props) => {
  const isHydrated = useHydration()
  const hero = data?.items[0].fields

  const renderOptions: Options = {
    renderMark: {
      [MARKS.ITALIC]: (text) => <i className="font-normal font-merriweather">{text}</i>
    }
  }

  if (!isHydrated)
    return (
      <div className="flex items-center bg-primary-blue justify-center w-full h-[40vh] lg:h-[90vh]">
        <Loading className="w-10 h-10 text-white" />
      </div>
    )

  return (
    <section className="overflow-hidden bg-primary-blue">
      <ExportedImage
        src="/static/images/hero-pma.png"
        alt=""
        width={580}
        height={450}
        className="object-cover w-full lg:hidden"
      />
      <Container className="flex lg:items-center lg:h-[90vh] relative z-10 py-6 lg:py-28">
        <figure className="flex flex-col w-full gap-7 lg:gap-14 lg:items-center lg:flex-row-reverse lg:justify-between">
          <ExportedImage
            src="/static/images/hero-pma.png"
            alt=""
            width={580}
            height={450}
            className="hidden rounded-md lg:block lg:w-5/12"
          />
          <figcaption className="flex items-start flex-col gap-3 text-white lg:w-7/12 max-w-[665px]">
            <label className="inline px-3 py-1 text-xs font-medium border border-white rounded-full lg:text-base">
              {hero.badge || 'Foreign Capital Investment'}
            </label>
            <div className="text-3xl font-bold leading-tight lg:leading-[80px] lg:text-6xl">
              {hero.title ? (
                documentToReactComponents(hero.title, renderOptions)
              ) : (
                <Fragment>
                  Your{' '}
                  <span className="font-normal font-merriweather">
                    <i>Reliable</i>
                  </span>{' '}
                  Investment Assistant in Indonesia
                </Fragment>
              )}
            </div>
            <p className="text-sm font-medium lg:text-base">
              {hero.subTitle ||
                'We are here so you can start making investments in Indonesia while we take care of the meticulous planning and understanding the local regulations.'}
            </p>

            <Button
              size="lg"
              variant="secondary"
              url={hero.buttonLink || '/kontak-kami'}
              className="w-40 h-12 my-2 font-semibold lg:mt-5 gtm-call-button"
            >
              {hero.buttonText || 'Contact Us'}
            </Button>
          </figcaption>
        </figure>
      </Container>

      <Buble className="h-[400px] w-[400px] -top-36 lg:right-[332px] hidden lg:block" />
      <Buble className="h-60 w-60 -bottom-14 -left-32" />
    </section>
  )
}
